export const NAME = 'counting';